import { request } from "./http";

export interface SanctionsCheck {
  id: string;
  user_id: string;
  user_email: string | null;
  user_name: string | null;
  vendor: string;
  status: "PASS" | "FAIL" | "REVIEW" | "ERROR";
  hit_count: number;
  hit_categories: string[];
  decision_note: string | null;
  decided_by: string | null;
  decided_at: string | null;
  created_at: string;
}

export const sanctions = {
  list: (status?: SanctionsCheck["status"], limit = 200) => {
    const qs = new URLSearchParams();
    if (status) qs.set("status", status);
    qs.set("limit", String(limit));
    return request<SanctionsCheck[]>(`/api/v1/admin/sanctions?${qs}`);
  },
  history: (userId: string) =>
    request<SanctionsCheck[]>(`/api/v1/admin/sanctions/users/${userId}`),
  decide: (checkId: string, body: { status: "PASS" | "FAIL"; note?: string }) =>
    request<SanctionsCheck>(`/api/v1/admin/sanctions/${checkId}/decide`, {
      method: "POST",
      body,
    }),
  rescan: (userId: string) =>
    request<SanctionsCheck>(`/api/v1/admin/sanctions/users/${userId}/rescan`, {
      method: "POST",
    }),
};
